import React, { Component } from "react";
import Footer from "../components/footer.component";
import Header from "../components/header.component";
import "../css/page.css";

import twitterIcon from "../images/web-icons/twitter-gray.svg";
import linkedInIcon from "../images/web-icons/linkedin-gray.svg";
import reportVisitService from "../reporting-visit/report-visit.service";

export default class ContactPage extends Component {
  componentDidMount() {
    document.title =
      "Get in touch | David Šimák - A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    return (
      <div>
        <Header lightColor={true} />
        <div className="page_title_container">
          <label class="big_title">Get in touch</label>
        </div>

        <div class="section">
          <p>
            Although I'm not currently looking for new job opportunities, my
            inbox is always open. Whether you have questions about me or my
            projects, ideas for new features, or just want to say hi, please
            don't hesitate to reach out! I'll try my best to respond to you as
            soon as possible.
          </p>
          <div className="contacts">
            <div className="contact_row">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/david-simak/"
                className="contact_row_link"
              >
                <img src={linkedInIcon} className="contact_row_icon" />
              </a>
              <a
                className="contact_row_link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/davidsimakdev"
              >
                <img src={twitterIcon} className="contact_row_icon" />
              </a>
            </div>
            <div className="contact_row">
              <a
                className="contact_row_link"
                target="_blank"
                rel="noopener noreferrer"
                href="mailto://david@davidsimak.dev"
              >
                david@davidsimak.dev
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
